import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import { WheelPage } from './pages/WheelPage'
import { HomePage } from './pages/HomePage'
import { AnalysisLandingPage } from './pages/AnalysisLandingPage'
import { ChatPage } from './pages/ChatPage'
import { DecisionAnalysisPage } from './pages/DecisionAnalysisPage'
import { ProsConsAnalysisPage } from './pages/ProsConsAnalysisPage'
import { CausalChainAnalysisPage } from './pages/CausalChainAnalysisPage'
import { ContextAnalysisPage } from './pages/ContextAnalysisPage'
import { MultiOptionAnalysisPage } from './pages/MultiOptionAnalysisPage'
import { HistoryPage } from './pages/HistoryPage'
import { Header } from './components/Header'
import AboutPage from './pages/AboutPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContactPage from './pages/ContactPage'
import Footer from './components/Footer'
import NotFoundPage from './pages/NotFoundPage'
import ToolsPage from './pages/ToolsPage'
import NamePickerPage from './pages/NamePickerPage'
import NumberPickerPage from './pages/NumberPickerPage'
import PickerPage from './pages/PickerPage'
import TeamPickerPage from './pages/TeamPickerPage'
import YesNoPickerPage from './pages/YesNoPickerPage'
import LetterPickerPage from './pages/LetterPickerPage'
import CountryPickerPage from './pages/CountryPickerPage'
import StatePickerPage from './pages/StatePickerPage'
import ColorPickerPage from './pages/ColorPickerPage'
import DatePickerPage from './pages/DatePickerPage'
import InstagramCommentPickerPage from './pages/InstagramCommentPickerPage'
import MLBPickerPage from './pages/MLBPickerPage'
import NBAPickerPage from './pages/NBAPickerPage'
import NFLPickerPage from './pages/NFLPickerPage'
import AuthPage from './pages/AuthPage'
import EmailVerificationPage from './pages/EmailVerificationPage'
import AuthCallbackPage from './pages/AuthCallbackPage'
import { AbTestResultsPage } from './pages/AbTestResultsPage'
import ContactAdminPage from './pages/ContactAdminPage'
import { useAuthStore } from './stores/authStore'

function App() {
  const { initialize } = useAuthStore()

  useEffect(() => {
    // 初始化认证状态
    initialize()
  }, [initialize])

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
          <Header />
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/wheel" element={<WheelPage />} />
              <Route path="/analysis" element={<AnalysisLandingPage />} />
              <Route path="/decision-analysis" element={<DecisionAnalysisPage />} />
              <Route path="/decision-analysis/pros-cons" element={<ProsConsAnalysisPage />} />
              <Route path="/decision-analysis/causal-chain" element={<CausalChainAnalysisPage />} />
              <Route path="/decision-analysis/context" element={<ContextAnalysisPage />} />
              <Route path="/decision-analysis/multi-option" element={<MultiOptionAnalysisPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/verify-email" element={<EmailVerificationPage />} />
              <Route path="/tools" element={<ToolsPage />} />
              <Route path="/tools/name-picker" element={<NamePickerPage />} />
              <Route path="/tools/number-picker" element={<NumberPickerPage />} />
              <Route path="/tools/picker" element={<PickerPage />} />
              <Route path="/tools/team-picker" element={<TeamPickerPage />} />
              <Route path="/tools/yesno-picker" element={<YesNoPickerPage />} />
              <Route path="/tools/letter-picker" element={<LetterPickerPage />} />
              <Route path="/tools/country-picker" element={<CountryPickerPage />} />
              <Route path="/tools/state-picker" element={<StatePickerPage />} />
              <Route path="/tools/color-picker" element={<ColorPickerPage />} />
              <Route path="/tools/date-picker" element={<DatePickerPage />} />
              <Route path="/tools/instagram-comment-picker" element={<InstagramCommentPickerPage />} />
              <Route path="/tools/mlb-picker" element={<MLBPickerPage />} />
              <Route path="/tools/nba-picker" element={<NBAPickerPage />} />
              <Route path="/tools/nfl-picker" element={<NFLPickerPage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/ab-test-results" element={<AbTestResultsPage />} />
              <Route path="/admin/contact-submissions" element={<ContactAdminPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  )
}

export default App 